import { Link } from 'react-router-dom';
import { Article } from '../types';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface ArticleCardProps {
  article: Article;
}

export const ArticleCard: React.FC<ArticleCardProps> = ({ article }) => {
  const timeAgo = formatDistanceToNow(new Date(article.publishedAt), { addSuffix: true, locale: ptBR });
  const displayTitle = article.titlePt || article.title;
  const displayExcerpt = article.summaryPt || article.excerpt;

  return (
    <article className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300">
      {/* Image */}
      {article.imageUrl && (
        <Link to={`/article/${article.slug}`}>
          <div className="aspect-video overflow-hidden">
            <img
              src={article.imageUrl}
              alt={displayTitle}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              loading="lazy"
            />
          </div>
        </Link>
      )}

      <div className="p-4">
        {/* Category and Source */}
        <div className="flex items-center justify-between mb-2">
          {article.category && (
            <Link
              to={`/category/${article.category.slug}`}
              className="text-xs font-semibold text-blue-600 hover:text-blue-800 uppercase"
            >
              {article.category.name}
            </Link>
          )}
          <span className="text-xs text-gray-500">{article.sourceName}</span>
        </div>

        {/* Title */}
        <Link to={`/article/${article.slug}`}>
          <h2 className="text-xl font-bold text-gray-900 mb-2 hover:text-blue-600 transition line-clamp-2">
            {displayTitle}
          </h2>
        </Link>

        {/* Excerpt */}
        {displayExcerpt && (
          <p className="text-gray-600 text-sm mb-3 line-clamp-3">{displayExcerpt}</p>
        )}

        {/* Meta */}
        <div className="flex items-center justify-between text-xs text-gray-500">
          <span>{timeAgo}</span>
          {article.views > 0 && (
            <div className="flex items-center space-x-2">
              <span>{article.views} visualizações</span>
            </div>
          )}
        </div>

        {/* Tags */}
        {article.tags && article.tags.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-2">
            {article.tags.slice(0, 3).map((articleTag) => (
              <Link
                key={articleTag.tag.id}
                to={`/tag/${articleTag.tag.slug}`}
                className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded hover:bg-gray-200 transition"
              >
                #{articleTag.tag.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </article>
  );
};
